/**
 * Helper function to display a given number of months.
 *
 * The original use was to be displayed like 4/humanizePeriod(4)
 *
 * @param months
 * @returns {string}
 */
export function humanizePeriod(months) {
    if (months === 1)
        return "month";
    if (months === 12)
        return "year";
    if (months % 12 === 0)
        return `${months / 12} years`;
    return `${months} months`;
}

/**
 * Helper function for getting a humanized version of a duration specified in days.
 *
 * @param days
 * @returns [int, str] - an array containing the duration and the duration unit.
 */
export function humanizePeriodUnitDays(days) {
    if (days === 1)
        return [days, "day"];
    if (days === 7) {
        return [days/7, "week"];
    }
    if (days % 7 === 0) {
        return [days/7, "weeks"];
    }
    return [days, "days"];
}


/**
 * Helper function for getting a humanized version of a monthly duration.
 *
 * @param months
 * @returns [int, str] - an array containing the duration and the duration unit.
 */
export function humanizePeriodUnitMonths(months) {
    if (months === 1)
        return [months, "month"];
    if (months === 12)
        return [months/12, "year"];
    if (months % 12 === 0)
        return [months / 12, "years"];
    return [months, "months"];
}
